import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const RestrictedError = () => {
    return (_jsx("div", { className: "flex flex-col min-h-screen items-center justify-center", children: _jsxs("div", { className: "", children: [_jsx("h2", { className: "text-2xl text-[##26292e] font-bold py-2", children: "SORRY. ACCESS RESTRICTED." }), _jsx("p", { className: "text-base text-[##26292e] font-normal py-2", children: "You do not have the right permissions to access this page." })] }) }));
};
export default RestrictedError;
